import { ErrorHandler, Injectable } from '@angular/core';
import * as Raven from 'raven-js';
import { ConfigService } from './config.service';

@Injectable()
export class CustomRavenErrorHandler implements ErrorHandler {
  constructor(private configService: ConfigService) {}

  handleError(err: any): void {
    this.configService.getValue('SENTRY_ENABLED') ? Raven.captureException(err) : new ErrorHandler().handleError(err);
  }
}

export const RavenErrorHandler = {
  provide: ErrorHandler,
  useClass: CustomRavenErrorHandler
};
